<template>
  <form @submit.prevent="onSaveNewTrip">
    <b-row>
      <b-col md="12">
        <div class="d-flex align-items-center justify-content-between">
          <button
            type="button"
            class="btn btn-outline-primary btn-menu"
            @click="closeSidebar('create-new-trip')"
          >
            Cancel & Close
          </button>

          <b-dropdown class="m-0 p-0 btn btn-outline-secondary">
            <template v-slot:button-content>
              <i class="fa fa-id-card"></i>
              Copy / Paste
            </template>
            <b-dropdown-item variant="dark" @click="saveDraft">Copy</b-dropdown-item>
            <b-dropdown-item variant="dark" @click="pasteDraft">Paste</b-dropdown-item>
          </b-dropdown>
        </div>
      </b-col>
      <b-col md="12">
        <form-wizard 
          title=""
          subtitle=""
          color="#334697"
          step-size="sm" 
          back-button-text="Back"
          next-button-text="Next Step"
          finish-button-text="Save & Close"
          @on-complete="onSaveNewTrip"
        >
          <tab-content title="Loading Point" label="1">
            <b-row>
              <b-col md="12">
                <h5 class="text-primary mb-2"><strong>Loading Activity Record</strong></h5>
              </b-col>
              <!-- <b-col md="3">
                <b-form-group label="Voyage For" label-for="voyage_for">
                  <template v-for="(item,index) in voyagefor">
                    <b-form-radio inline v-model="form.voyageFor" :name="item.name" :key="index" :value="item.value" :disabled="item.disabled || $route.query?.preview">{{ item.label }}</b-form-radio>
                  </template>
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="['others'].includes(form.voyageFor)"> 
                <b-form-group label="Voyage For Other" label-for="voyageForOtherValue">
                  <b-form-input class="bg-white" type="text" v-model="form.voyageForOtherValue" :disabled="$route.query?.preview"></b-form-input>
                </b-form-group>
              </b-col> -->
              <b-col md="3">
                <b-form-group label="Port of Loading" label-for="port_of_loading">
                  <v-select :disabled="$route.query?.preview" v-model="form.portLoading" label="text" :options="positionListPOL" :reduce="positionListPOL => positionListPOL.value" placeholder="Select..." class="bg-white"></v-select>
                </b-form-group>
              </b-col>
              <b-col v-if="['Other'].includes(form.portLoading)" md="3">
                <b-form-group label="Other POL" label-for="POL">
                  <b-form-input 
                    class="bg-white" type="text" v-model="form.portLoadingOther" :disabled="$route.query?.preview" placeholder="Type Text"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Agent POL" label-for="agent_pol" class="text-truncate">
                  <b-form-input :disabled="$route.query?.preview" v-model="form.agentPol" type="text" id="agent_pol" placeholder="Type Text" class="bg-white"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Is Pol Sts Mv:" label-for="kind-fleet">
                    <b-form-checkbox :disabled="$route.query?.preview" v-model="form.polStsMv" name="check-button" switch inline>
                      No / Yes
                    </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="form.polStsMv">
                <b-form-group label="Pol Mv Name" label-for="pol_mv_name" class="text-truncate">
                  <b-form-input v-model="form.polMvName" type="text" id="pol_mv_name" placeholder="Type Text" :class="{'bg-white':form.polStsMv}" :disabled="!form.polStsMv || $route.query?.preview"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Pol grab Type" label-for="pod_grab_type">
                  <v-select :disabled="$route.query?.preview" v-model="form.polGrabType" label='text' :options="polGrabTypeOpt" :reduce="item => item.value"  placeholder="Select Pol Grab Type" class="bg-white"></v-select>
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="form.polGrabType == 'gearless'">
                <b-form-group label="Pol Fc Name" label-for="pol_fc_name" class="text-truncate">
                  <b-form-input v-model="form.polFcName" :class="{'bg-white' : form.polGrabType == 'gearless'}" :disabled="form.polGrabType !== 'gearless' || $route.query?.preview" type="text" id="pol_mv_name" placeholder="Type Text"></b-form-input>
                </b-form-group>
              </b-col>
              <!-- Data Not Yet Provided -->
              <b-col md="3" class="mb-2"> 
                <b-form-group label="NOR" label-for="nor" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" v-model="form.polNor" class="custom-date-picker w-100" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
              </b-col>
              <!-- Data Not Yet Provided -->
              <b-col md="3" class="mb-2"> 
                <b-form-group label="NOA" label-for="noa" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" v-model="form.polNoa" class="custom-date-picker w-100" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Anchor Up" label-for="polAnchorUp" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.polArrivalTime, form.polAnchorUp, 'Anchor Up', 'Arrival Time', 1)" class="custom-date-picker w-100" v-model="form.polAnchorUp" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 1" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col  md="3" class="mb-2">
                <b-form-group label="In Position / Berthing" label-for="polBerthing" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.polAnchorUp, form.polBerthing, 'Berthing', 'Anchor Up', 2)"  class="custom-date-picker w-100" v-model="form.polBerthing" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 2" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Commenced" label-for="polCommenced" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.polBerthing, form.polCommenced, 'Commenced', 'Berthing', 3)" class="custom-date-picker w-100"v-model="form.polCommenced" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 3" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Completed" label-for="completed" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.polCommenced, form.polCompleted, 'Completed', 'Commenced', 4)" class="custom-date-picker w-100" v-model="form.polCompleted" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 4" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3">
                <b-form-group label="Draught Survey" label-for="polDraughtSurvey" class="text-truncate mb-0">
                  <b-form-input :disabled="$route.query?.preview" v-model="form.polDraughtSurvey" type="number" step="0.0001" id="polDraughtSurvey" placeholder="Type Number" class="bg-white" @change="() => {
                    form.cargoLoading = form.polDraughtSurvey
                  }"></b-form-input>
                </b-form-group>
                <span class="text-black">{{ form.polDraughtSurvey ? Number(form.polDraughtSurvey).toLocaleString() : 0 }}</span>
              </b-col>
              <b-col md="3" class="mb-2"> 
                <b-form-group label="BL Date" label-for="blDate" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" class="custom-date-picker w-100" v-model="form.polBlDate" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 5" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2"> 
                <b-form-group label="Second Berthing" label-for="polCastIn" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" v-model="form.polCastIn" class="custom-date-picker w-100" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 5" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Cast out" label-for="polCastOut" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.polCompleted, form.polCastOut, 'Cast Out', 'Completed', 5)"  class="custom-date-picker w-100" v-model="form.polCastOut" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 5" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="LHV" label-for="polLhv" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.polCastOut, form.polLhv, 'LHV', 'Cast Out', 6)"  class="custom-date-picker w-100" v-model="form.polLhv" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 6" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Document On Board POL" label-for="document_on_board" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.polLhv, form.polDocOnBoard, 'Doc on Board', 'LHV', 7)" class="custom-date-picker w-100" v-model="form.polDocOnBoard" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 7" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Departure to POD" label-for="polDeparture" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.polDocOnBoard, form.polDeparture, 'Departure', 'Doc on Board', 8)" class="custom-date-picker w-100" v-model="form.polDeparture" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 8" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="12" class="mb-2"> 
                <b-form-group label="Remarks" label-for="polCastIn" class="text-truncate mb-0">
                  <b-form-textarea :disabled="$route.query?.preview" placeholder="Type Text..." v-model="form.polRemark" class="bg-white">
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>
          <tab-content title="Discharge Point" label="2">
            <b-row>
              <b-col md="12">
                <h5 class="text-primary mb-2"><strong>Discharge Activity Record</strong></h5>
              </b-col>
              <b-col md="3">
                <b-form-group label="Port of Discharge" label-for="port_of_discharge">
                  <v-select class="bg-white" v-model="form.portDischarge" label="text" :options="positionListPOD" :reduce="positionListPOD => positionListPOD.value" placeholder="Select..."></v-select>
                </b-form-group>
              </b-col>
              <b-col v-if="['Other'].includes(form.portDischarge)" md="3">
                <b-form-group label="Other POD" label-for="POD">
                  <b-form-input 
                    class="bg-white" type="text" v-model="form.portDischargeOther" placeholder="Type Text"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Agent POD" label-for="agent_pod" class="text-truncate">
                  <b-form-input :disabled="$route.query?.preview" v-model="form.agentPod" type="text" id="agent_pod" placeholder="Type Text" class="bg-white" ></b-form-input>
                </b-form-group>
              </b-col>  
              <b-col md="3">
                <b-form-group label="Is Pod Sts Mv:" label-for="pod_sts_mv">
                    <b-form-checkbox :disabled="$route.query?.preview" v-model="form.podStsMv" name="check-button" switch inline>
                      No / Yes 
                    </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="form.podStsMv">
                <b-form-group label="Pod Mv Name" label-for="pod_mv_name" class="text-truncate" >
                  <b-form-input v-model="form.podMvName" type="text" id="pol_mv_name" placeholder="Type Text" :class="{'bg-white':form.podStsMv}" :disabled="!form.podStsMv || $route.query?.preview"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Pod grab Type" label-for="pod_grab_type">
                  <v-select :disabled="$route.query?.preview" v-model="form.podGrabType" label='text' :options="polGrabTypeOpt" :reduce="item => item.value"  placeholder="Select POd Grab Type" class="bg-white"></v-select>
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="form.podGrabType == 'gearless'">
                <b-form-group label="Pod Fc Name" label-for="pod_fc_name" class="text-truncate">
                  <b-form-input v-model="form.podFcName" :class="{'bg-white' : form.podGrabType == 'gearless'}" :disabled="form.podGrabType !== 'gearless' || $route.query?.preview" type="text" id="pol_mv_name" placeholder="Type Text"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Arrival Time POD" label-for="arrival_time_pod" class="text-truncate">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(currentValidTime, form.podArrivalTime)"  class="custom-date-picker" v-model="form.podArrivalTime" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
              </b-col>
              <b-col md="3" class="mb-2"> 
                <b-form-group label="NOR" label-for="nor" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" v-model="form.podNor" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
              </b-col>
              <b-col md="3" class="mb-2"> 
                <b-form-group label="NOA" label-for="noa" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" v-model="form.podNoa" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Anchor Up" label-for="podAnchorUp" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.podArrivalTime, form.podAnchorUp, 'Anchor Up', 'Arrival Time', 11)" class="custom-date-picker" v-model="form.podAnchorUp" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 11" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="In Position / Berthing" label-for="in_position_pod" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.podAnchorUp, form.podBerthing, 'Berthing', 'Anchor Up', 12)" class="custom-date-picker" v-model="form.podBerthing" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 12" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Commenced" label-for="commenced_pod" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.podBerthing, form.podCommenced, 'Commenced', 'Berthing', 13)" class="custom-date-picker" v-model="form.podCommenced" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 13" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Completed" label-for="completed_pod" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.podCommenced, form.podCompleted, 'Completed', 'Commenced', 14)" class="custom-date-picker" v-model="form.podCompleted" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 14" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3">
                <b-form-group label="Draught Survey" label-for="podDraughtSurvey" class="text-truncate mb-0">
                  <b-form-input :disabled="$route.query?.preview" v-model="form.podDraughtSurvey" type="number" step="0.0001" id="podDraughtSurvey" placeholder="Type Number" class="bg-white"></b-form-input>
                </b-form-group>
                <span class="text-black">{{ form.podDraughtSurvey ? Number(form.podDraughtSurvey).toLocaleString() : 0 }}</span>
              </b-col>
              <b-col md="3" class="mb-2"> 
                <b-form-group label="Second Berthing" label-for="polCastIn" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" v-model="form.podCastIn" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 5" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Cast Out" label-for="podCastOut" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" @change="validationTime(form.podCompleted, form.podCastOut, 'Cast Out', 'Completed', 15)" class="custom-date-picker" v-model="form.podCastOut" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 15" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="3" class="mb-2">
                <b-form-group label="Departure to POL" label-for="podDeparture" class="text-truncate mb-0">
                  <date-picker :disabled="$route.query?.preview" class="custom-date-picker" v-model="form.podDeparture" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                </b-form-group>
                <small v-if="errorTimeText && errorTimeIndex === 18" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
              </b-col>
              <b-col md="12" class="mb-2"> 
                <b-form-group label="Remarks" label-for="polCastIn" class="text-truncate mb-0">
                  <b-form-textarea  :disabled="$route.query?.preview"placeholder="Type Text..."  v-model="form.podRemark" class="bg-white">
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>
          <tab-content title="Review Activiy" label="3">
            <b-row>
              <b-col md="12">
                <div class="d-flex overflow-auto">
                  <table size="sm" class="table table-sm">
                    <thead>
                      <tr class="text-truncate" style="min-width:200px">
                        <th style="width:5px" class="sticky-col text-center">#</th>
                        <th style="min-width:170px">Set as End Trip</th>
                        <th style="min-width:170px" class="text-left">Fleet</th>
                        <th style="min-width:170px">Trip Info</th>
                        <th style="min-width:170px">Start Date</th>
                        <th style="min-width:170px">End Date</th>
                        <th style="min-width:170px">Current Position</th>
                        <th style="min-width:170px">Port Loading</th>
                        <th style="min-width:170px">Port Discharge</th>
                        <th style="min-width:170px">Agent POL</th>
                        <th style="min-width:170px">Agent POD</th>
                        <th style="min-width:170px">PIC / PE</th>
                        <th style="min-width:170px">Departure</th>
                        <th style="min-width:170px">ETA</th>
                        <th style="min-width:170px">Updated Today</th>
                        <th style="min-width:170px">Reason</th>
                        <th style="min-width:170px">Idle (Hours)</th>
                        <th style="min-width:170px">Remarks</th>
                        <th style="min-width:170px">Document on Board</th>
                        <th style="min-width:170px" class="text-right">Cargo Loading</th>
                      </tr>
                    </thead>
                    <tbody v-if="assign?.length > 0">
                      <tr class="text-truncate" v-for="(val, index) in assign" :key="index" style="min-width:200px">
                        <td style="width:5px; cursor: pointer" class="sticky-col text-center" @click="assign?.splice(index, 1)">
                          <i class="fa fa-trash text-danger" />
                        </td>
                        <td class="text-center">
                          <b-form-checkbox
                            v-if="val?.reason?.name === 'Unloading'"
                            name="check-button"
                            switch
                            inline
                            :checked="val.isEndTrip"
                            @change="setOnlyOneIsEndTrip(index)"
                          >
                          </b-form-checkbox>
                        </td>
                        <td class="text-truncate text-left">
                          <div class="d-flex flex-column">
                            <span class="fs-5 mb-1" v-for="(v, v_index) in val?.vehicle" :key="`h-v-${v_index}`">
                              <b-badge variant="success">{{ v.name }}</b-badge>
                            </span>
                            <b-badge variant="primary" class="mb-1">{{formatString(val?.voyageType)}}</b-badge>
                          </div> 
                        </td>
                        <td class="text-truncate">
                          <div class="d-flex flex-column" v-if="val?.tripId">
                            <div class="d-flex align-items-center text-primary">
                              <i class="fas fa-map-pin mr-2"></i>
                              {{val?.polTrip}}
                            </div> 
                            <div class="dashed-border"></div>
                            <div class="d-flex align-items-center text-primary">
                              <i class="fa fa-map-pin mr-2"></i>
                              {{val?.podTrip}}
                            </div>
                          </div>
                          <div v-else class="d-flex align-items-center text-danger">
                            <i class="ri-close-circle-line mr-2"></i>
                              No trip yet
                          </div>
                        </td>
                        <td class="text-truncate">
                          {{ val?.startDate ? moment(val.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
                        </td> 
                        <td class="text-truncate">
                          {{ val?.endDate ? moment(val.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
                        </td>  
                        <td class="text-truncate">{{ val?.currentPosition }}</td>
                        <td class="text-truncate">{{ val?.portLoading?.portName }}</td>
                        <td class="text-truncate">{{ val?.portDischarge?.portName }}</td>
                        <td class="text-truncate">{{ val?.agentPol }}</td>
                        <td class="text-truncate">{{ val?.agentPod }}</td>
                        <td>
                          <div class="d-flex flex-column">
                            <span class="fs-5 mb-1" v-for="(v, v_index) in val.pic" :key="`h-v-${v_index}`">
                              <b-badge variant="info">{{ v?.name }}</b-badge>
                            </span>
                          </div>
                        </td>
                        <td class="text-truncate">
                          {{ val?.podDeparture ? moment(val?.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
                        </td>
                        <td class="text-truncate">
                          -
                        </td>
                        <td class="text-truncate">
                          {{ moment().format('DD MMM YYYY HH:mm') }}
                        </td>
                        <td>{{val?.reason?.name}}</td>
                        <td>{{val?.activityDurationFormat}}</td>
                        <td>{{val?.remark}}</td>
                        <td class="text-truncate">
                          {{ val.polDocOnBoard ? moment(val?.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm'): '-'}}
                        </td>
                        <td class="text-right">{{Number(val?.cargoLoading || 0)?.toLocaleString()}}</td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <th class="text-center" colspan="20">No Selected Activity List.</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </tab-content>
        </form-wizard>

        <!-- <template v-if="saving">
          <LoadingOverlayFullscreen :visible="saving" :text="'Saving...'" />
        </template> -->
      </b-col>
    </b-row>
  </form>
</template>

<script>
import moment from 'moment'
import { voyagesActions, fleetsActions, projectsActions, reasonsActions, portsActions, usersActions, busdevActions } from '@src/Utils/helper'
import LoadingOverlayFullscreen from '@src/components/LoadingOverlayFullscreen.vue'

export default {
  name:'SlideFormCreateNewTrip',
  props:{
    refreshData:{
      type:Function,
      default:() => {}
    },   
    checkedHistory:{
      type:Array,
      default:() => []
    },   
    closeSidebar:{
      type:Function,
      default:() => {}
    },  
    unCheckAll:{
      type:Function,
      default:() => {}
    },  
  },
  components:{
    LoadingOverlayFullscreen
  },
  data(){
    return {
      saving: false, 
      currentValidTime: null,
      errorTimeText: '',
      errorTimeIndex: null,
      errorValidation: false,

      positionListPOL: [
        { value: 'Other', text: 'Other Position', portType: 'OTHERS' }
      ],  
      positionListPOD: [
        { value: 'Other', text: 'Other Position', portType: 'OTHERS' }
      ], 
      positionListTextPOL: [
        { value: 'Other', text: 'Other Position', portType: 'OTHERS' }
      ],
      positionListTextPOD: [
        { value: 'Other', text: 'Other Position', portType: 'OTHERS' }
      ],

      projectOptions: [],
      polGrabTypeOpt:[
        {
          text:'Gearless',
          value:'gearless'
        },
        {
          text:'Gear and Grab',
          value:'gearless_and_grab'
        }
      ],
      voyagefor: [
        {
          name: 'number',
          label: 'Loading',
          value: 'loading',
          disabled: false
        },
        {
          name: 'number',
          label: 'Discharge',
          value: 'discharge',
          disabled: false
        },
        {
          name: 'number',
          label: 'Other',
          value: 'others',
          disabled: false
        }
      ], 

      form: {
        portLoading: null,
        portLoadingOther: '',
        portDischarge: null,
        portDischargeOther: '',
        "agentPol": "",
        "agentPod": "",
        "polCargoUnit": "",
        "polAnchorUp": "",
        "polArrivalTime": "",
        "polBerthing": "",
        "polCommenced": "",
        "polCompleted": "",
        "polDocOnBoard": "",
        "polDeparture": "",
        "polCastOut": "",
        "polLhv": "",
        "polRemark": "",
        "podCargoUnit": "",
        "podAnchorUp": "",
        "podLhv": "",
        "podCastOut": "",
        "podDeparture": "",
        "podArrivalTime": "",
        "podBerthing": "",
        "podCommenced": "",
        "podCompleted": "",
        "podRemark": "",
        // "voyageFor": "loading",
        // "voyageForOtherValue": "",
        "polCastIn": "",
        "polNoa": "",
        "polNor": "",
        "polDraughtSurveyDate": "",
        "podCastIn": "",
        "podNoa": "",
        "podNor": "",
        // "podDraughtSurveyDate": ""
      },
      "assign": [],
    }
  },
  async mounted() {
    await this.getProjectList()
    await this.getPortListText()
  },
  watch:{
    checkedHistory: {
      async handler(newValue) {
        let unloadingFound = false;
        this.assign = []
        this.assign = newValue?.map((val) => {
          let isEndTrip = false;
          if (!unloadingFound && val?.reason?.name === 'Unloading') {
            isEndTrip = val.isEndTrip;
            unloadingFound = true;
          }
          return {
            ...val,
            isEndTrip
          };
        }).sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

        await this.getProjectList()
      },
      deep: true,  // Ensures Vue detects changes inside the array
      immediate: true // Runs the watcher immediately
    }
  },
  methods: {
    ...busdevActions,
    ...voyagesActions,
    ...fleetsActions,
    ...projectsActions,
    ...reasonsActions,
    ...portsActions,
    ...usersActions,
    setOnlyOneIsEndTrip(selectedIndex) {
      this.assign = this.assign.map((item, index) => ({
        ...item,
        isEndTrip: index === selectedIndex
      }));
    },
    formatString(str) {
      return str
        .replace(/_/g, " ") // Replace underscores with spaces
        .toLowerCase()       // Convert to lowercase
        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
    },
    saveDraft(){
      localStorage.setItem('form_create_assign_trip', JSON.stringify(this.form));
      this.$swal('Saved.', 'Data Activity Saved.', 'success')
    },
    pasteDraft(){
      const savedData = localStorage.getItem('form_create_assign_trip');
      if (savedData) {
        let saved = JSON.parse(savedData);

        this.form = {
          ...this.form,
          ...saved,
        }
        this.$swal('Paste.', 'Data Paste.', 'success')
      } else {
        this.$swal('Oops.', 'No data on draft.', 'warning')
      }
    },
    resetForm(){
      this.form = {
        "portLoading": null,
        "portDischarge": null,
        "agentPol": "",
        "agentPod": "",
        "polCargoUnit": "",
        "polAnchorUp": "",
        "polArrivalTime": "",
        "polBerthing": "",
        "polCommenced": "",
        "polCompleted": "",
        "polDocOnBoard": "",
        "polDeparture": "",
        "polCastOut": "",
        "polLhv": "",
        "polRemark": "",
        "podCargoUnit": "",
        "podAnchorUp": "",
        "podLhv": "",
        "podCastOut": "",
        "podDeparture": "",
        "podArrivalTime": "",
        "podBerthing": "",
        "podCommenced": "",
        "podCompleted": "",
        "podRemark": "",
        // "voyageFor": "loading",
        // "voyageForOtherValue": "",
        "polCastIn": "",
        "polNoa": "",
        "polNor": "",
        "polDraughtSurveyDate": "",
        "podCastIn": "",
        "podNoa": "",
        "podNor": "",
        // "podDraughtSurveyDate": ""
      }
      this.assign = []
    },

    async getPortListText () {
      let params = {
        active: true,
        search: '',
        page: 1,
        perPage: 250
      }
      const res = await this.getPorts(params)
      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          res.data.data.forEach((val, index) => {
            if(val.portType === 'LOADING_PORT'){
              this.positionListTextPOL.push({ value: val?.portName, text: `${val?.portName}`, ...val })
              this.positionListPOL.push({ value: val.id, text: `${val?.portName}`, ...val })
            } else if(val.portType === 'DISCHARGING_PORT'){
              this.positionListTextPOD.push({ value: val?.portName, text: `${val?.portName}`, ...val })
              this.positionListPOD.push({ value: val.id, text: `${val?.portName}`, ...val })
            }
          })
        }
      } else {
        this.$swal(
          `Oops!`,
          res.data.data,
          'error'
        )
      }
    },
    async getProjectList() {
      let params = {
        active: true,
        search: '',
        page: 1,
        perPage: 99999
      }
      const res = await this.getProjects(params)

      if((res?.data?.status == 'success' || res?.data?.status == true) && res.data.data.length > 0) {
        res.data.data?.map(val => {
          val.subProject?.map(obj => {
            this.projectOptions.push({
              value: obj.id,
              text: `${val.projectName} - ${obj?.name}`,
              bdCustomer: val.bdCustomer,
              isSts: val.isSts,
              sts: val.sts,
              vehicleType: val.vehicleType,
              projectId: val.id,
              projectName:val.projectName,
              projectSub:obj?.name,
              location:val.location,
              status:val.active,
            })
          })
        })
      }
    },

    handleChangeProject(selectedValue) {
      if(selectedValue){
        let projectSelected = this.projectOptions.find(obj => obj.value === selectedValue)
        this.form.polStsMv = projectSelected.sts
        this.form.podStsMv = projectSelected.sts
      }
    }, 

    validationTime(oldTime, currentTime, labelCurrent, labelBefore, indexes){
      // Parse the datetime strings using Moment.js
      let old = moment(new Date(oldTime), 'DD-MM-YYYY HH:mm');
      let current = moment(new Date(currentTime), 'DD-MM-YYYY HH:mm');

      this.errorTimeIndex = indexes

      if (current.isSameOrBefore(old)) {
        this.errorTimeText = `${labelCurrent} must greater than ${labelBefore}`
        this.errorValidation =  true
        return
      } 

      this.errorTimeText = ''
      this.currentValidTime = currentTime
      this.errorValidation =  false
    },

    async onSaveNewTrip(){
      let payload = {
        trip: {
          ...this.form
        },
        assign: this.assign?.map(val => {
          return {
            "voyageActivityId": val.id,
            "isEndTrip": val.isEndTrip
          }
        })
      }

      this.saving = true

      const res = await this.assignAndCreateTrip({data: payload})

      if (res.status === 'success') {
        this.$swal('Create & Assign Trip!', res.data.message, 'success')
        this.resetForm()
        this.refreshData()
        this.unCheckAll()
        this.closeSidebar('create-new-trip')
      } else {
        if (res.data.message != null) {
          this.$swal('Error', res.data.message, 'error')
        } else {
          this.$swal(
            'Error',
            'Something wrong with the server. Please try again later.',
            'error'
          )
        }
      }

      this.saving = true
    }
  },
}
</script>

<style scoped>
.dashed-border {
  padding: 10px;
  border-left: 2px dashed black; /* Dashed left border */
  margin-left:3px
}
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 2;
}
/* Column-specific left offsets */
.col-1 {
  left: 0;
  z-index: 3;
  min-width: 50px;
  max-width: 50px;
}
.col-2 {
  left: 50px; /* adjust this to match col-1 width */
  z-index: 3;
  min-width: 200px;
}
</style>